var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-combobox",
        _vm._b(
          {
            staticClass: "form-control form-control-sm",
            class: _vm.childclass,
            attrs: {
              items: _vm.shippers,
              "search-input": _vm.search,
              "hide-details": "",
              placeholder: _vm.childplaceholder,
              clearable: _vm.clearable,
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.search = $event
              },
              "update:search-input": function ($event) {
                _vm.search = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "no-data",
                fn: function () {
                  return [
                    _c("v-list-item", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.loading == "search"
                              ? "Buscando..."
                              : "No hay datos disponibles"
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.model,
              callback: function ($$v) {
                _vm.model = $$v
              },
              expression: "model",
            },
          },
          "v-combobox",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }